import { GAME_SOUNDS } from "../cfg/constants/game-constants";
const ASSETS_PREFIX_URL = "game/src/assets/img/";
export class AssetsPreloader {
    constructor(scene) {
        this.scene = scene;
    }
    // Requires use of this.scene.load.start in the case of calling anywhere outside a scene preload function.
    loadBootSceneAssets() {
        this.scene.load.maxParallelDownloads = 10;
        this.scene.load.xhr.timeout = 10;
        this.scene.load.setBaseURL(""); // Since in react we alter the url using router-dom. It's necessary to set this to '/'
        this.scene.load.path = ASSETS_PREFIX_URL;
        // this.scene.load.start();
    }
    onProgress(v) {
        // console.log(v);
        // if(v == 1)
    }
    // Requires use of this.scene.load.start in the case of calling anywhere outside a scene preload function.
    loadGameSceneAssets() {
        this.scene.load.path = `${ASSETS_PREFIX_URL}`;
        this.scene.load.image("bg_circles", "background_circles.png");
        this.scene.load.image("whiteBG", "white_bg.png");
        this.scene.load.image("bg1", "white_bg1.png");
        this.scene.load.image("button1", "button1.png");
        this.scene.load.image("button21", "button21.png");
        this.scene.load.image("button31", "button31.png");
        this.scene.load.image("button2", "button2.png");
        this.scene.load.image("button22", "button22.png");
        this.scene.load.image("clickBoxReadMore", "clickBoxReadMore.png");
        this.scene.load.image("game_button", "game_button.png");
        this.scene.load.image("dot", "dot.png");
        this.scene.load.image("popup", "popup3.png");
        this.scene.load.image("popup1", "popup1.png");
        this.scene.load.image("question", "question.png");
        this.scene.load.image("buttonCircle", "buttonCircle.png");
        this.scene.load.image("buttonCircle1", "buttonCircle2.png");
        this.scene.load.json("gameData", "gameData.json");
        this.scene.load.image("endPopup", "endPopup.png");
        this.scene.load.image("next", "Next.png");
        this.scene.load.image("longButton", "longButton.png");
        this.scene.load.image("longButton1", "longButton1.png");
        this.scene.load.image("testImage", "testImage.jpg");
        this.scene.load.image("PPPLogo", "PPP.jpg");
        this.scene.load.image("varsityLogo", "Varsity.png");
        this.scene.load.image("SoundOff", "Mute.png");
        this.scene.load.image("SoundOn", "Sound.png");
        this.scene.load.image("timerbg", "Timer.png");
        this.scene.load.image("disclaimer", "disclaimer.png");
        this.scene.load.image("logo", "trends.png");
        this.scene.load.image("start", "Start.png");
        this.scene.load.image("play", "Play.png");
        this.scene.load.image("play_again", "Play-again.png");
        this.scene.load.image("share", "Share.png");
        this.scene.load.image("next_g", "next_g.png");
        this.scene.load.image("you_are_close", "you_are_close.png");
        this.scene.load.image("spotText", "spotText.png");
        this.scene.load.image("closeButton", "close.png");
        this.scene.load.image("click", "click.png");
        this.scene.load.image("twitterLogo", "twitterLogo.png");
        this.scene.load.image("facebookLogo", "facebookLogo.png");
        this.scene.load.image("instagramLogo", "instagramLogo.png");
        // AUDIO
        this.scene.load.path = `game/src/assets/audio/`;
        for (let i = 0; i < GAME_SOUNDS.length; ++i) {
            this.scene.load.audio(GAME_SOUNDS[i].key, `${GAME_SOUNDS[i].key}.${GAME_SOUNDS[i].ext}`);
        }
        this.scene.add.text(0, 0, "LOADING...").setFontSize(75).setOrigin(0.5);
        this.scene.load.on("progress", this.onProgress.bind(this));
        this.scene.load.start();
    }
    createAnimations() { }
}
